import "./CareerHero.css";
import { Link } from "react-router-dom";

export default function CareerHero() {
  return (
    <section className="career-hero">
      <div className="ch-overlay"></div>

      <div className="ch-content">
        <h1 className="ch-title">Career</h1>
        <p className="ch-subtitle">
          Build your future with us — <span>Join our team</span>
        </p>

        <div className="ch-breadcrumb">
          <Link to="/">Home</Link>
          <span className="ch-arrow">›</span>
          <span>Career</span>
        </div>

        <div className="ch-scroll">
          <div className="scroll-icon"></div>
        </div>
      </div>
    </section>
  );
}
